import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./realestate.css";
import HeroFooter from "../../components/footer";
import ScrollToTop from "./scrolltop";

const categories = [
  "Contract Management",
  "Foreign Collaborations",
  "Joint Ventures",
  "Corporate Law",
  "Information Technology",
  "Business Ventures",
  "MSME",
  "Start-up India Initiatives",
  "Property and Real Estate"
];

// Map each category to a custom slug
const categoryMapping = {
  "Contract Management": "contract",
  "Foreign Collaborations": "foreign",
  "Joint Ventures": "joint",
  "Corporate Law": "corporate",
  "Information Technology": "information",
  "Business Ventures": "buisness",
  "MSME": "msme",
  "Start-up India Initiatives": "startup",
  "Property and Real Estate": "realestate"
};

const InformationTechnology = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  
  return (
    <div className="practice-page">
         <ScrollToTop/>
      <div className="mobile-menu-button" onClick={toggleSidebar}>
        <i className="fa fa-bars" aria-hidden="true"></i>
      </div>
      
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <h2 className="sidebar-title">Our Offerings</h2>
        <ul className="category-list">
          {categories.map((category, index) => (
            <li key={index} className={category === "Information Technology" ? "active" : ""}>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={`/${categoryMapping[category]}`}
              >
                {category}
              </Link>
            </li>
          ))}
        </ul>
      </aside>
      
      <main className="conten">
        <h2>Information Technology</h2>
        <p className="intro">
          InduratnaLaw’s Information Technology practice supports clients through the challenges of the digital era.
          We offer comprehensive legal services to address IT compliance, cybersecurity, and technology licensing issues.
        </p>
        <section className="details">
          <h3>Our Expertise</h3>
          <p>
            Our team is well-versed in the evolving landscape of technology law. We help businesses protect their digital assets, ensure regulatory compliance, and navigate complex IT contracts with clarity.
          </p>
          <h3>Key Services</h3>
          <ul>
            <li>Technology Licensing and Agreement Drafting</li>
            <li>Cybersecurity and Data Privacy Compliance</li>
            <li>IT Regulatory Advisory</li>
            <li>Digital Transformation Legal Support</li>
            <li>Intellectual Property Protection in Tech</li>
          </ul>
          <h3>Why Choose InduratnaLaw?</h3>
          <p>
            With a focus on innovation and risk mitigation, our IT legal services empower you to leverage technology while safeguarding your business.
          </p>
        </section>
      </main>
      <HeroFooter />
    </div>
  );
};

export default InformationTechnology;
